<template>
  <div class="p_w-top clearBoth">

    <!-- 开奖区域 -->
    <div class="top-win fl clearBoth">
      <template v-if="load || records.length">
        <template v-if="records.length">
          <p>{{name}}</p>
          <!--<p v-if="have_next=='no'">第<span class="tc">{{phase}}</span>期</p>-->
          <p>第<span class="tc">{{phase}}</span>期</p>
          <slot name="recodeNumber"></slot>

          <!--<div class="r">
            <v-select class="select" v-model="music" :options="options"></v-select>
          </div>-->
        </template>
        <p v-else>暂无开奖信息</p>
      </template>
    </div>
    <!-- 开奖区域 end -->

    <!-- 倒计时 -->
    <v-top-time @change="change" :remain_time="remain_time"
                @before_end="$emit('before_end')"
                @end="handleEnd"
                class="fr o_timer" :next_phase="next_phase"
                :block_time="block_time"
                :open_time="open_time"></v-top-time>
    <!-- 倒计时 end -->

  </div>
</template>

<script>
  import VSelect from '../c_select';
  import VTopTime from '../c_top-time';
  import {mapState} from 'vuex';

  export default {
    name: "c_top-win",
    props: {
      remain_time: Number,
      block_time: Number,
      next_phase: String,
      open_time: {
        type: String,
        default: ''
      },
      have_next: String,
      name: {
        type: String,
        default: ''
      },

      // 期数
      phase: {
        type: String,
        default: ''
      },

      records: {
        type: Array,
        default() {
          return []
        }
      }
    },
    components: {
      VSelect,
      VTopTime
    },
    computed: {
      ...mapState({
        load: state => state.load
      })
    },
    data() {
      return {
        time: 0,
        music: 0,
        options: [
          {
            label: '关闭',
            value: 0,
          },
          {
            label: '铃声1',
            value: 1,
          },
          {
            label: '铃声2',
            value: 2,
          },
          {
            label: '铃声3',
            value: 3,
          },
        ],
      }
    },
    mounted() {
    },
    watch: {
      deep: true,
      handle() {
      }
    },
    methods: {
      change(time) {
        this.time = time;
        // 在外部判断是否是封盘状态，如果是封盘状态不可操作
        this.$emit('change', this.time);
      },
      handleEnd(ctx) {
        this.$emit('end', ctx);
      },
      showResult() {
        this.$emit('showResult')
      }
    }
  }
</script>

<style scoped lang="stylus">
 @media screen and (max-width: 900px) {
    .top-win{/*width:300px !important;*/}
    .top-win p{font-size:12px !important;padding-right:10px !important}
  }
  .p_w-top
    /*height 102px*/
    height 25px

    .top-win
      /*width: 558px;*/
      width:calc(100% - 477px);
      height 100%
      padding 0px 0 0 5px
      position relative
      box-sizing border-box
      font-weight bold
      border-radius 2px
      background-color #ffffff

      p {
        font-size 14px
        box-sizing border-box
        line-height 25px
        display inline-block
      }

      .r
        top 1px
        right 15px
        z-index 100
        position absolute

        .select, .btn-res {
          font-weight normal
          display inline-block
        }

        .btn-res {
          color #fff
          width 90px
          height 26px
          border 0
          background linear-gradient(#FF9900, #FF6600)
          margin-left 5px
          border-radius 50px
        }
</style>



// WEBPACK FOOTER //
// src/components/c_top/index.vue